import { createRoot } from 'react-dom/client';
import './index.css';

import { Amplify } from 'aws-amplify';
import App from './App';
import config from './amplifyconfiguration.json';

Amplify.configure(config);
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
